import React from "react";
import { Alert, Button, Spinner } from "reactstrap";

interface SectionStateProps {
  loading: boolean;
  error: string | null;
  description: string;
  onRetry: () => void;
}

const SectionState = ({ loading, error, description, onRetry }: SectionStateProps) => {
  if (loading) {
    return (
      <div className="d-flex align-items-center gap-2 text-muted">
        <Spinner size="sm" />
        <span>{description}</span>
      </div>
    );
  }

  if (error) {
    return (
      <Alert color="danger" className="d-flex align-items-center justify-content-between">
        <span className="me-3">{error}</span>
        <Button color="danger" size="sm" onClick={onRetry}>
          Reintentar
        </Button>
      </Alert>
    );
  }

  return null;
};

export default SectionState;
